import { RootState } from 'redux/schemas';
import { MentoringProgramActionItemTemplate } from 'redux/schemas/models/mentoring-program-action-item-templates';

// eslint-disable-next-line import/prefer-default-export
export const getProgramActionItemTemplates = (programId: number) => (state: RootState): MentoringProgramActionItemTemplate[] => (
  Object.values(state.models.mentorshipProgramActionItemTemplates[programId] || {})
);
